import { GridImage } from "components/PhotoGrid/types";

// Cache array of photos passed as a parameter
export const precacheImages = (photos: GridImage[]) => {
  photos.forEach(({ src }) => {
    const image = new Image();
    image.src = src as string;
  });
};
